export default __webpack_public_path__ + "static/media/check.717abd12.svg";